import styled from "@emotion/styled";
import { deepPurple, grey } from "@mui/material/colors";
import { Box } from "@mui/system";

export const StyledDropzone = styled(Box)(() => ({
  width: "314px",
  height: "234px",
  padding: "1rem",
  backgroundColor: grey[50],
  border: "2px dashed " + grey[400],
  borderRadius: "10px",
  color: grey[800],
  transition: "border-color 143ms linear",
  boxSizing: "border-box",
  "&: hover": {
    borderColor: "#0d0d0d",
    cursor: "pointer",
  },
}));

export const DropzoneContent = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  wordBreak: "break-word",
}));

export const FileLabel = styled("p")(() => ({
  margin: 0,
  textAlign: "center",
  fontWeight: 600,
}));

export const FileHelper = styled("p")(() => ({
  margin: 0,
  paddingTop: "0.625rem",
  fontSize: "0.75rem",
  color: grey[600],
  textAlign: "center",
  wordBreak: "break-all",
}));